import { get } from '@classic/Foundation/Services/ApiService'
import { HasLoggedOut, UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'

type GetAccountDetailsRes = {
  accountName: string
  accountNumber: number
  balance: string
  blackBookAlertCount: number
  activeCampaignsCount: number
}

export async function fetchAccountDetailsForMenu(): Promise<GetAccountDetailsRes> {
  const res = await get<GetAccountDetailsRes>({ url: '/api/account/detailsformenu' })

  if (res.accountNumber === 0) {
    HasLoggedOut()
    throw new Error('ACCOUNT_LOGGED_OUT')
  }

  const balanceCleaned = (res.balance || '').replace('$', '').replace(/,/g, '')
  UpdateAccountBalance({ balance: balanceCleaned })

  return res
}
